export default __webpack_public_path__ + "static/media/Blade's Spauld of Waning Dusk.20f8003e.jpg";